import styles from "../styles/FeaturedMenu.module.css";
import useScrollDirection from "../hooks/useScrollDirection";
import useInView from "../hooks/useInView";

function MenuCard({ item }) {
  const direction = useScrollDirection();
  const [ref, visible] = useInView();

  return (
    <div className={styles.card} ref={ref}>
      <div className={styles.imageWrapper}>
        <img
          src={item.image}
          alt={item.title}
          className={`${styles.image} ${
            visible
              ? direction === "down"
                ? styles.imageDown
                : styles.imageUp
              : ""
          }`}
        />
      </div>

      <div className={styles.content}>
        <div className={styles.top}>
          <h3>{item.title}</h3>
          <span>{item.price}</span>
        </div>

        <p>{item.description}</p>
      </div>
    </div>
  );
}

export default MenuCard;